class ConfiguratorModalInfo extends HTMLElement {
  constructor() {
    super();
    this.initialize();  
  }

  initialize() {
    this.setupAccordion();
  }

  setupAccordion() {
    this.querySelectorAll('details').forEach(details => {
      const summary = details.querySelector('summary');
      const content = details.querySelector('.configurator__info-accordion-content');
      const expandIcon = details.querySelector('.configurator__info-accordion-icon--expand');
      const collapseIcon = details.querySelector('.configurator__info-accordion-icon--collapse');

      if (summary && content) {
        // Set initial height and icon states
        content.style.height = '0px';
        expandIcon.style.display = 'block';
        collapseIcon.style.display = 'none';

        summary.addEventListener('click', (e) => {
          e.preventDefault();
          
          if (details.open) {
            // Closing
            content.style.height = content.scrollHeight + 'px';
            content.offsetHeight; // Force reflow
            content.style.height = '0px';
            
            expandIcon.style.display = 'block';
            collapseIcon.style.display = 'none';
            
            content.addEventListener('transitionend', function handler() {
              details.open = false;
              content.removeEventListener('transitionend', handler);
            }, { once: true });
          } else {
            // Opening
            details.open = true;
            content.style.height = content.scrollHeight + 'px';
            
            expandIcon.style.display = 'none';
            collapseIcon.style.display = 'block';
            
            content.addEventListener('transitionend', function handler() {
              content.style.height = 'auto';
              content.removeEventListener('transitionend', handler);
            }, { once: true });
          }
        });
      }
    });
  }
} 

customElements.define('configurator-modal-info', ConfiguratorModalInfo);